export default "__VITE_ASSET__ea919702__"